import { spacing } from "@indeed/ifl-tokens/react-native";
import React, { type ReactNode } from "react";
import { StyleSheet } from "react-native";
import { SafeAreaView, useSafeAreaInsets } from "react-native-safe-area-context";

import { Box, ScrollView } from "../../../mads";
import { ScreenKeyboardAvoidingView } from "../ScreenKeyboardAvoidingView/ScreenKeyboardAvoidingView";

export interface ReportJobFormLayoutProps {
  children: ReactNode;
  /** Overrides the contextual bottom inset used for keyboard avoidance and content padding. */
  bottomInsetOverride?: number;
}

/**
 * Shared safe-area + keyboard + scroll shell around {@link ReportJobForm}.
 */
export function ReportJobFormLayout({ children, bottomInsetOverride }: ReportJobFormLayoutProps) {
  const { bottom: contextualBottom } = useSafeAreaInsets();
  const bottom = bottomInsetOverride ?? contextualBottom;

  return (
    <SafeAreaView style={styles.safeArea} edges={["left", "right", "bottom"]}>
      <ScreenKeyboardAvoidingView safeAreaBottomInset={bottom}>
        <ScrollView
          sx={styles.content}
          keyboardShouldPersistTaps="handled"
          keyboardDismissMode="interactive"
          automaticallyAdjustKeyboardInsets={false}
        >
          <Box sx={{ paddingBottom: bottom }}>{children}</Box>
        </ScrollView>
      </ScreenKeyboardAvoidingView>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  safeArea: {
    flex: 1,
  },
  content: {
    paddingLeft: spacing.s4,
    paddingRight: spacing.s4,
  },
});
